module.exports = __webpack_public_path__ + "img/lms-fragentutor-bg.1107f43b.png";